import Login from "../components/Authentication/Login";
import Register from "../components/Authentication/Register";
import ForgotPassword from "../components/Authentication/ForgotPassword";
import NewPassword from "../components/Authentication/NewPassword";

const routes = [
  {
    path: "/login",
    name: "login",
    component: Login,
    meta: { requiresVisitor: true },
  },
  {
    path: "/register",
    name: "register",
    component: Register,
    meta: { requiresVisitor: true },
  },
  {
    path: "/forgot-password",
    name: "forgotPassword",
    component: ForgotPassword,
    meta: { requiresVisitor: true },
  },
  {
    path: "/new-password/:request",
    name: "newPassword",
    props: true,
    component: NewPassword,
    meta: { requiresVisitor: true },
  },
];

export default routes;
